// extracted by mini-css-extract-plugin
export default {"green":"Toaster_green__zDlyG"};